function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8667 1.30695C11.5671 0.898619 12.4329 0.898619 13.1333 1.30695L20.9827 5.88345L12 11.1207L3.01733 5.88345L10.8667 1.30695ZM3 7.88053L10.875 12.3782V23L4.13411 19.15C3.43283 18.7495 3 18.0038 3 17.1962V7.88053ZM5.24999 11.7557V17.1972L8.62497 19.1248V13.6833L5.24999 11.7557ZM13.125 12.3782L21 7.88053V17.1962C21 18.0038 20.5672 18.7495 19.8659 19.15L13.125 23V12.3782ZM18.75 17.1972V11.7557L15.375 13.6833V19.1248L18.75 17.1972Z",
  fill: "#561951"
});

function Svg3DTopView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DTopView);
export default __webpack_public_path__ + "static/media/3d_top_view.4136611e.svg";
export { ForwardRef as ReactComponent };